import { Box, HStack, Text, Icon, BoxProps } from '@chakra-ui/react';

import ContentContainer from '~/containers/Content';

import { IoTimeOutline } from 'react-icons/io5';

type PreorderTimeBarProps = {
  value: string;
  containerProps?: BoxProps;
};
export default function PreorderTimeBar({ value, containerProps = {} }: PreorderTimeBarProps) {
  return (
    <Box px={4} {...containerProps}>
      <ContentContainer>
        <HStack py={2}>
          <Icon as={IoTimeOutline} color="primary" boxSize="1.5rem" />
          <Text flex="1" fontWeight="bold">
            {value}
          </Text>
        </HStack>
      </ContentContainer>
    </Box>
  );
}
